import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Home from "./Home";
import Login from "./Login";
import RecuperarSenha from "./RecuperarSenha";
import RecuperarSenhaToken from "./RecuperarSenhaToken";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import AdminIgreen from "./AdminIgreen";
import AdminIgreenPublico from "./AdminIgreenPublico";
import DashboardWrapper from "./DashboardWrapper";
import DashboardGeral from "./DashboardGeral";
import Igreen from "./Igreen";
import IgreenCadastro from "./IgreenCadastro";
import IgreenCadastroAP from "./IgreenCadastroAP";
import LandingIgreenAP from "./LandingIgreenAP";
import LandingAP from "./LandingAP";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/senha" element={<RecuperarSenha />} />
        <Route path="/recuperarsenha" element={<RecuperarSenhaToken />} />
        <Route path="/apadminlogin" element={<AdminLogin />} />
        <Route path="/apadmin" element={<AdminDashboard />} />
        <Route path="/apadmin/igreen" element={<AdminIgreen />} />
        <Route path="/apadmin/igreen-publico" element={<AdminIgreenPublico />} />
        <Route path="/dashboard" element={<DashboardWrapper />} />
        <Route path="/dashboard-geral" element={<DashboardGeral />} />
        <Route path="/igreen" element={<Igreen />} />
        <Route path="/igreencadastro" element={<IgreenCadastro />} />
        <Route path="/igreencadastroap" element={<IgreenCadastroAP />} />
        <Route path="/ldigreenap" element={<LandingIgreenAP />} />
        <Route path="/ldap" element={<LandingAP />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
